// Icons
import HomeIcon from "@material-ui/icons/Home";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import AssignmentIcon from "@material-ui/icons/Assignment";
import MapIcon from "@material-ui/icons/Map";
import downloadIcon from "@material-ui/icons/GetApp";

// Pages
import {
  Home,
  Report,
  Viewer,
  ReportViewer,
  Download,
  Plot,
} from "./pages";

export default {
  items: [
    {
      path: "/plot",
      name: "プロット",
      key: "plot",
      type: "link",
      icon: MapIcon,
      component: Plot,
      sideBar: true,
    },
    {
      path: "/home",
      name: "撮影",
      key: "home",
      type: "link",
      icon: CameraAltIcon,
      component: Home,
      sideBar: true,
    },
    {
      path: "/report",
      name: "報告",
      key: "report",
      type: "link",
      icon: AssignmentIcon,
      component: Report,
      sideBar: true,
    },
    {
      path: "/viewer/:pid",
      name: "ビューワー",
      key: "view",
      type: "link",
      icon: HomeIcon,
      component: Viewer,
      sideBar: false,
    },
    {
      path: "/report-viewer/:pid",
      name: "報告ビューワー",
      key: "view",
      type: "link",
      icon: HomeIcon,
      component: ReportViewer,
      sideBar: false,
    },
    {
      path: "/download",
      name: "ダウンロード",
      key: "download",
      type: "link",
      icon: downloadIcon,
      component: Download,
      sideBar: true,
    },
  ],
};
